export const Relationship = [
  {
    value: "validationError",
    displayValue: "Please Select"
  },
  {
    value: "spouse",
    displayValue: "Spouse"
  },
  {
    value: "son",
    displayValue: "Son"
  },
  {
    value: "daughter",
    displayValue: "Daughter"
  },
  {
    value: "father",
    displayValue: "Father"
  },
  {
    value: "mother",
    displayValue: "Mother"
  },
  {
    value: "brother",
    displayValue: "Brother"
  },
  {
    value: "sister",
    displayValue: "Sister"
  },
  {
    value: "in_laws",
    displayValue: "In Laws"
  },
  {
    value: "other",
    displayValue: "Other"
  }
];



// WEBPACK FOOTER //
// ./src/views/Fna/steps/objects/Dependants.js